<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Broadcast</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link :to="'/message_report/broadcast'">Broadcast</router-link>
                  </li>
                  <li v-if="broadcastId != ''" class="breadcrumb-item">
                    <router-link :to="'/message_report/broadcast/info/?id=' + broadcastId">{{ broadcastParamSt.title
                      }}</router-link>
                  </li>
                  <li class="breadcrumb-item active">{{ title }} {{ copyLabel }}</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div v-if="isSending" class="text-center text-info">
                <i>Preparing, please wait...</i>
                <br />
                <Skeleton :count="1" />
              </div>
              <form-wizard @on-validate="onValidate" :title="''" :subtitle="''"
                :finishButtonText="(broadcastParamSt.sending_options == '1') ? 'Send' : 'Schedule'"
                :start-index.sync="activeIndex" color="#70C95A">
                <Skeleton v-if="isLoading" :count="1" />
                <wizard-step slot-scope="props" slot="step" :tab="props.tab" :transition="props.transition"
                  :index="props.index">
                  <div slot="active-step" style="display: flex; justify-content: center; align-items: center">
                    <lottie v-if="props.index == 0" :options="animationsForm1" :height="65" :width="65" />
                    <lottie v-else-if="props.index == 1" :options="animationsForm2" :height="65" :width="65" />
                    <lottie v-else-if="props.index == 2" :options="animationsForm3" :height="65" :width="65" />
                  </div>
                </wizard-step>
                <tab-content :before-change="validationForm1" title="Sender" icon="fa fa-list-alt">
                  <form1 :activeIndex="activeIndex" />
                  <!-- ini tab product -->
                </tab-content>

                <tab-content :before-change="validationForm2" title="Content" icon="fa fa-list-alt">
                  <form2 :activeIndex="activeIndex" />
                </tab-content>
                <tab-content title="Preview" :after-change="tabPreview" icon="fa fa-list-alt">
                  <form3 :activeIndex="activeIndex" />
                </tab-content>

                <template slot="footer" slot-scope="props">
                  <!-- <div
                    v-if="props.isLastStep && broadcastParam.broadcast_id!='' && broadcastParam.is_recurring==1"
                    class="col-md-12 text-muted"
                    style="font-size:11px;"
                  >
                    <hr />*) Click
                    <b>Update Only Button</b> for ignoring Send Now option. Your broadcast will not be sent, just update the recurring schedule.
                    <hr />
                  </div>-->
                  <div class="wizard-footer-left">
                    <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()"
                      :style="props.fillButtonStyle">Previous</wizard-button>
                    <!-- <wizard-button v-if="props.isLastStep" @click.native="onComplete(0)" class="btn btn-primary"
                      :style="props.fillButtonStyle">Draft</wizard-button> -->
                    <!-- <wizard-button
                      v-if="props.isLastStep && broadcastParam.broadcast_id!='' && broadcastParam.is_recurring==1"
                      @click.native="onComplete(1,1)"
                      class="btn btn-primary"
                      :style="props.fillButtonStyle"
                    >Update Only</wizard-button>-->
                    <!-- <button
                      v-if="broadcastParam.broadcast_id!='' && broadcastParam.is_recurring==1"
                      @click.prevent="onComplete(1,1)"
                      class="btn btn-lg btn-info"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-save"></i>
                      Update Only
                    </button>-->
                  </div>
                  <!-- <div
                    class="wizard-footer-left"
                    v-if="props.isLastStep && broadcastParam.broadcast_id!='' && broadcastParam.is_recurring==1"
                  >
                    <hr />
                    <wizard-button
                      @click.native="onComplete(1,1)"
                      :style="props.fillButtonStyle"
                    >Update Only</wizard-button>
                    <hr />
                  </div>-->
                  <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
                      :style="props.fillButtonStyle">Next</wizard-button>

                    <template v-else>
                      <span v-if="!isMobile()" style="margin-top:20px;margin-right:60%;">
                        <center>
                          <!-- isLoadingBc: {{isLoadingBc}} -->
                          <wizard-button v-if="!isLoadingBc" @click.native="onComplete(1)"
                            class="wizard-footer-right finish-button" :style="props.fillButtonStyle">
                            {{ props.isLastStep ? (
                      (broadcastParamSt.sending_options == '1') ? 'Send Now' : 'Schedule'
                    ) : 'Next' }}
                          </wizard-button>
                          <wizard-button v-else :disabled="true" @click.native="onComplete(1)"
                            class="wizard-footer-right finish-button"
                            :style="props.fillButtonStyle">Loading...</wizard-button>
                        </center>
                      </span>
                      <div v-else style="margin-top:0px;">
                        <!-- <center> -->
                          <wizard-button v-if="!isLoadingBc" @click.native="onComplete(1)"
                            class="wizard-footer-right finish-button" :style="props.fillButtonStyle">
                            {{ props.isLastStep ? (
                      (broadcastParamSt.sending_options == '1') ? 'Send Now' : 'Schedule'
                    ) : 'Next' }}
                          </wizard-button>
                          <wizard-button v-else :disabled="true" @click.native="onComplete(1)"
                            class="wizard-footer-right finish-button" :style="props.fillButtonStyle">Loading...
                            </wizard-button>
                        <!-- </center> -->
                      </div>
                    </template>
                  </div>
                </template>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

import Lottie from "vue-lottie";
import animationReview from "@/assets/lottie/review.json";
import animationSchedule from "@/assets/lottie/schedule.json";
import animationStore from "@/assets/lottie/viralPost.json";
import animationFilter from "@/assets/lottie/filter.json";
import animationLoadProduct from "@/assets/lottie/userConnection.json";
import animationProcessing from "@/assets/lottie/processing.json";
import animationData from "@/assets/animation.js";
import animationData2 from "@/assets/animation2.js";
import rainbow from "@/assets/lottie/rainbow.json";
import {
  FormWizard,
  TabContent,
  WizardStep,
  WizardButton
} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Form1 from "./componentsImport/form1.vue";
import Form2 from "./componentsImport/form2.vue";
import Form3 from "./componentsImport/form3.vue";

export default {
  components: {
    Form1,
    Form2,
    Form3,
    Lottie,
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    FormWizard,
    TabContent,
    WizardStep,
    WizardButton
  },
  data() {
    return {
      isCopy: false,
      isSending: false,
      isLoadingBc: false,
      broadcastId: "",
      title: "Tambah Broadcast",
      copyLabel: " via Import",
      broadcastParam: {},
      isLoading: false,
      activeIndex: 0,
      animationsForm1: { animationData: animationLoadProduct, loop: true },
      animationsForm2: { animationData: animationStore, loop: true },
      animationsForm3: { animationData: animationReview, loop: true },
      // animationsForm4: { animationData: animationSchedule, loop: true },
      // animationsForm5: { animationData: animationReview, loop: true },
      // animationsForm6: { animationData: animationProcessing, loop: true },
      // defaultOptions: { animationData: animationData, loop: false },
      // defaultOptions2: { animationData: rainbow, loop: false },
      animationSpeed: 1
    };
    //  isactive : true
  },
  computed: {
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    }
    // isShowForm() {
    //   return this.$store.state.monitoring.isShowForm;
    // }
  },
  watch: {
    broadcastParamSt: {
      handler: async function (val, oldVal) {
        if (val != oldVal) {
          this.broadcastParam = val;
        }
      },
      deep: true
    }
  },
  created() {
    let id = this.$route.query.id;
    if (typeof id != "undefined" && id != "") {
      this.title = "Ubah Broadcast";
      this.broadcastId = id;
      // console.log("id", id);
      this.detailBroadcast(id);
    }
    let copy = this.$route.query.copy;
    this.isCopy = false;
    if (typeof copy != "undefined" && copy == "1") {
      this.copyLabel = " - COPY";
      this.isCopy = true;
    }
  },
  methods: {
    tabPreview() {
      console.log("previewwww")
      this.$root.$emit("searchDataImport");

    },
    async detailBroadcast(id) {
      this.isLoading = true;

      //set false dulu
      this.$store.dispatch("omniroom/setIsShowBroadcast", false);

      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("omniwa/detailBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData = JSON.parse(data.raw);
          // console.log("formdataaa", formData);
          if (formData.is_send == 1 && this.isCopy == false) {
            this.$fire({
              title: "Error",
              text:
                "Hanya mengizinkan pesan dengan status Draft yang bisa diubah.",
              type: "error",
              timer: 3000
            });
            this.$router.push("/message_report/broadcast");
            return false;
          }
          this.isLoading = false;
        });
      formData.buttons = await [];
      await this.$store
        .dispatch("omniwa/detailButtonsBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          if (data != null && data.length) {
            data.forEach((value, idx) => {
              formData.buttons.push(value.id);
            });
          }
        });
      // console.log(formData);
      formData.broadcast_id = id;
      await this.$store.dispatch("omniwa/actBroadcastParamSt", formData);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async onComplete(isPublish) {
      this.isLoadingBc = await true;
      this.broadcastParam = await this.broadcastParamSt;
      let copy = this.$route.query.copy;
      if (typeof copy != "undefined" && copy == "1") {
        this.broadcastParam.broadcast_id = "";
      }
      await this.bcMessageHandler(isPublish);
    },
    async buildDestinationFromGroup() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        // console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      // await this.$store
      //   .dispatch("contact/getContactList", this.contactListParam)
      //   .then(response => {
      //     let { data } = response;
      //     data.forEach((rowCon, ind) => {
      //       let arrCon = {
      //         id: rowCon.id,
      //         phone_number: rowCon.phone_number,
      //         is_group: rowCon.is_group,
      //         phone_number_group: rowCon.phone_number_group
      //       };
      //       this.broadcastParam.to.push(arrCon);
      //     });
      //   });
    },
    async buildDestinationFromTags() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        // console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      // await this.$store
      //   .dispatch("contact/getContactListFromTags", this.contactListParam)
      //   .then(response => {
      //     let { data } = response;
      //     data.forEach((rowCon, ind) => {
      //       let arrCon = {
      //         id: rowCon.id,
      //         phone_number: rowCon.phone_number,
      //         is_group: rowCon.is_group,
      //         phone_number_group: rowCon.phone_number_group
      //       };
      //       this.broadcastParam.to.push(arrCon);
      //     });
      //   });
    },
    async bcMessageHandler(isSend = 0, updateOnly = 0) {
      this.broadcastParam.to_test = [];

      if (isSend == 0) {
        this.broadcastParam.is_send = 0;
      } else {
        this.broadcastParam.is_send = 1;
      }
      if (this.broadcastParam.is_group == 1) {
        // if (this.broadcastParam.to_group.length == 0) {
        //   this.isLoadingBc = await false;

        //   //error no destination
        //   // error
        //   this.$fire({
        //     title: "Error",
        //     text: "Destination is required!",
        //     type: "error",
        //     timer: 2000
        //   }).then(r => { });
        //   return;
        // }
        if (this.broadcastParam.is_group_type == "tags") {
          await this.buildDestinationFromTags();
        } else {
          await this.buildDestinationFromGroup();
        }
      }

      //validasi data
      // if (
      //   this.broadcastParam.to.length == 0 &&
      //   this.broadcastParam.to_group.length == 0
      // ) {
      //   //error no destination
      //   // error
      //   this.$fire({
      //     title: "Error",
      //     text: "Destination is required!",
      //     type: "error",
      //     timer: 2000
      //   }).then(r => { });
      //   return;
      // }
      if (
        this.broadcastParam.message.message_type != "text" &&
        this.broadcastParam.message.file_url == ""
      ) {
        this.isLoadingBc = await false;

        //error no media
        this.$fire({
          title: "Error",
          text:
            "File is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => { });
        return;
      }

      // if (
      //   this.broadcastParam.message.message_type == "text" &&
      //   this.broadcastParam.message.text.trim() == ""
      // ) {
      //   this.isLoadingBc = await false;

      //   //error no text for type text
      //   this.$fire({
      //     title: "Error",
      //     text:
      //       "Text is required for " +
      //       this.broadcastParam.message.message_type +
      //       " message!",
      //     type: "error",
      //     timer: 2000
      //   }).then(r => { });
      //   return;
      // }

      // return;

      console.log("aaaaa", this.broadcastParamSt)

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {

        if (r.value == true) {
          if (updateOnly == 1) {
            //maka hanya update data
            this.broadcastParam.update_only = true;
          } else {
            this.broadcastParam.update_only = false;
          }

          this.isSending = await true;
          // this.emojiToggle(false);
          this.broadcastParam.message.text = await this.remove_tags(
            this.broadcastParam.message.text
          );

          this.broadcastParam.is_recurring = this.broadcastParamSt.is_recurring;
          this.broadcastParam.recurring_form = this.broadcastParamSt.recurring_form;

          let newButtons = [];
          // console.log("this.broadcastParam.buttons",this.broadcastParam.buttons)
          if (this.broadcastParam.interactive_message_status == true) {
            // newButtons = this.broadcastParam.buttons;
            if (this.broadcastParam.buttons.length) {
              this.broadcastParam.buttons.forEach((btnId, idx) => {
                if (btnId != "") {
                  newButtons.push(btnId);
                }
              });
            }
          }

          this.broadcastParam.buttons = newButtons;
          // console.log("newButtons", newButtons);
          await this.$store
            .dispatch("omniwa/sendBroadcastImport", this.broadcastParam)
            .then(response => {
              this.isLoadingBc = false;

              this.files = [];
              this.selectedLicense = [];
              this.selectedContactGroup = [];
              this.selectedContact = [];
              // this.isSending = false;
              if (this.broadcastParam.broadcast_id == "") {
                this.broadcastParam = {
                  //from state
                  form_speed: {
                    delay_interval: { wait_min: 0, wait_max: 0 },
                    rest_mode: { stop_after: 0, rest_for: 0 },
                  },
                  speed_mode: "safe",
                  speed_wait_min: 0,
                  speed_wait_max: 0,
                  speed_stop_after: 0,
                  speed_rest_for: 0,
                  title: "",
                  provider: "whatsapp",
                  to_group: [],
                  to: [],
                  is_group: this.broadcastParam.is_group, //for group set 1, for personal set 0
                  is_group_type: this.broadcastParam.is_group_type, //group/tags
                  license_id: "",
                  message: {
                    text: "",
                    message_type: this.broadcastParam.message.message_type, //text,image,document
                    file_url: ""
                  },
                  sending_options: 1,
                  sending_schedule: "",
                  is_recurring: 0,
                  recurring_form: {
                    recurrence: "",
                    recurrence_every: "",
                    recurrence_annually_month: "",
                    recurrence_end: "never",
                    recurrence_end_date: ""
                  },
                  is_send: 1,
                  to_test: [],
                  interactive_message_status: false,
                  interactive_message_type: "button_text",
                  buttons: ["", "", "", "", "", "", "", "", "", ""]
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {
                this.$router.push({
                  path: `/message_report/broadcast/info?id=` + response.data.id
                });
              });
              this.searchData();
              var elem = this.$refs.dismisModal;
              elem.click();
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
              this.isLoadingBc = false;
            });
        } else {
          this.isLoadingBc = false;
          this.isSending = false;
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    onValidate: function (validateResult, activeIndex) {
      // console.log("onValidate RUN");
      this.$root.$emit("on-validate", validateResult, activeIndex);

      // alert("Yay. Done!");
    },
    validationForm2() {
      // console.log("validation Form 2", this.broadcastParamSt);
      if (
        this.broadcastParamSt.broadcast_id == ""
      ) {
        this.$fire({
          title: "Error Text",
          text: "Mohon Upload file pesan anda terlebih dahulu",
          type: "error",
          timer: 2000
        });
        return false;
      } else if (
        this.broadcastParamSt.success_import < 1
      ) {
        this.$fire({
          title: "Error Text",
          text: "Pesan yang akan dikirim tidak tersedia. Sukses:" + this.broadcastParam.success_import + "; Gagal:" + this.broadcastParam.error_import,
          type: "error",
          timer: 2000
        });
        return false;
      } else {
        if (
          this.broadcastParamSt.message.file_url == "" &&
          this.broadcastParamSt.message.message_type == "image"
        ) {
          this.$fire({
            title: "Error File",
            text: "File is required for Media Message",
            type: "error",
            timer: 2000
          });
          return false;
        }
      }
      return true;
    },
    validationForm1() {
      if (this.broadcastParamSt.title == "") {
        this.$fire({
          title: "Error Title",
          text: "Title is required",
          type: "error",
          timer: 2000
        });
        return false;
      }
      if (this.broadcastParamSt.license_id == "") {
        this.$fire({
          title: "Error Send From",
          text: "Send From is required",
          type: "error",
          timer: 2000
        });
        return false;
      }

      // if (
      //   this.broadcastParamSt.to_group.length < 1 &&
      //   this.broadcastParamSt.to.length < 1
      // ) {
      //   this.$fire({
      //     title: "Error Destination",
      //     text: "Destination is required",
      //     type: "error",
      //     timer: 2000
      //   });
      //   return false;
      // }

      return true;
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "form-send"
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/wizardImport.vue